import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import './VociListino.css';

// Editor del listino della scheda: una lista di "voci" (pacchetti-festa o prodotti).
// `value` è l'array delle voci, `onChange` riceve il nuovo array.

export const MODALITA = [
  { value: 'fisso', label: 'prezzo fisso' },
  { value: 'da', label: 'a partire da' },
  { value: 'al_kg', label: 'al kg' },
  { value: 'cad', label: 'a pezzo (cad.)' },
  { value: 'supplemento', label: 'supplemento (+)' },
];

export const vuotaVoce = (tipo = 'principale') => ({
  tipo,
  titolo: '',
  prezzo: '',
  prezzo_modalita: 'fisso',
  durata: '',
  max_bambini: '',
  prezzo_bambino_extra: '',
  eta_min: '',
  eta_max: '',
  cosa_include: [],
  opzioni: [],
  note: '',
});

// Limite di voci per i fornitori free (coerente con FREE_MAX_VOCI del backend).
export const FREE_MAX_VOCI = 1;

function VociListino({ value = [], onChange, maxVoci = Infinity, onUpgrade }) {
  const voci = Array.isArray(value) ? value : [];
  const pieno = voci.length >= maxVoci;

  const setVoce = (idx, patch) =>
    onChange(voci.map((v, i) => (i === idx ? { ...v, ...patch } : v)));

  const rimuoviVoce = (idx) => onChange(voci.filter((_, i) => i !== idx));

  const aggiungiVoce = (tipo) => onChange([...voci, vuotaVoce(tipo)]);

  // opzioni (varianti / fasce quantità / gusti) di una voce
  const setOpzione = (vi, oi, patch) =>
    setVoce(vi, {
      opzioni: voci[vi].opzioni.map((o, i) => (i === oi ? { ...o, ...patch } : o)),
    });
  const aggiungiOpzione = (vi) =>
    setVoce(vi, { opzioni: [...(voci[vi].opzioni || []), { etichetta: '', prezzo: '' }] });
  const rimuoviOpzione = (vi, oi) =>
    setVoce(vi, { opzioni: voci[vi].opzioni.filter((_, i) => i !== oi) });

  const renderVoce = (v, idx) => (
    <div key={idx} className={`voce-card ${v.tipo === 'extra' ? 'is-extra' : ''}`}>
      <div className="voce-head">
        <input
          type="text"
          className="voce-titolo"
          value={v.titolo}
          onChange={(e) => setVoce(idx, { titolo: e.target.value })}
          placeholder={v.tipo === 'extra' ? 'Es. Party Box, Bandierina…' : 'Es. Baby Party, Cupcake…'}
        />
        <button type="button" className="voce-remove" onClick={() => rimuoviVoce(idx)} title="Rimuovi voce">
          <Trash2 size={18} />
        </button>
      </div>

      <div className="voce-row">
        <div className="voce-field">
          <label>Prezzo (€)</label>
          <input
            type="number" min="0" step="0.01"
            value={v.prezzo}
            onChange={(e) => setVoce(idx, { prezzo: e.target.value })}
            placeholder="Es. 200"
          />
        </div>
        <div className="voce-field">
          <label>Modalità prezzo</label>
          <select value={v.prezzo_modalita} onChange={(e) => setVoce(idx, { prezzo_modalita: e.target.value })}>
            {MODALITA.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>
      </div>

      {/* Dettagli tipici dei pacchetti-festa (facoltativi) */}
      <div className="voce-row">
        <div className="voce-field">
          <label>Durata</label>
          <input type="text" value={v.durata}
            onChange={(e) => setVoce(idx, { durata: e.target.value })} placeholder="Es. 1 ora" />
        </div>
        <div className="voce-field">
          <label>Max bambini</label>
          <input type="number" min="0" value={v.max_bambini}
            onChange={(e) => setVoce(idx, { max_bambini: e.target.value })} placeholder="Es. 10" />
        </div>
        <div className="voce-field">
          <label>€ a bambino extra</label>
          <input type="number" min="0" step="0.01" value={v.prezzo_bambino_extra}
            onChange={(e) => setVoce(idx, { prezzo_bambino_extra: e.target.value })} placeholder="Es. 15" />
        </div>
      </div>

      <div className="voce-row">
        <div className="voce-field">
          <label>Età min</label>
          <input type="number" min="0" max="18" value={v.eta_min}
            onChange={(e) => setVoce(idx, { eta_min: e.target.value })} />
        </div>
        <div className="voce-field">
          <label>Età max</label>
          <input type="number" min="0" max="18" value={v.eta_max}
            onChange={(e) => setVoce(idx, { eta_max: e.target.value })} />
        </div>
      </div>

      <div className="voce-field">
        <label>Cosa include (una voce per riga)</label>
        <textarea
          rows="3"
          value={(v.cosa_include || []).join('\n')}
          onChange={(e) => setVoce(idx, { cosa_include: e.target.value.split('\n') })}
          placeholder={'Location\nMerenda\nGadget finale'}
        />
      </div>

      <div className="voce-field">
        <label>Opzioni / varianti (es. gusti, fasce quantità, personalizzazioni)</label>
        {(v.opzioni || []).map((o, oi) => (
          <div className="opzione-row" key={oi}>
            <input
              type="text" value={o.etichetta}
              onChange={(e) => setOpzione(idx, oi, { etichetta: e.target.value })}
              placeholder="Es. 24 pz / Personalizzato / Fragola"
            />
            <input
              type="number" min="0" step="0.01" value={o.prezzo}
              onChange={(e) => setOpzione(idx, oi, { prezzo: e.target.value })}
              placeholder="€ (facolt.)"
            />
            <button type="button" className="voce-remove" onClick={() => rimuoviOpzione(idx, oi)} title="Rimuovi opzione">
              <Trash2 size={16} />
            </button>
          </div>
        ))}
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => aggiungiOpzione(idx)}>
          <Plus size={16} /> Aggiungi opzione
        </button>
      </div>

      <div className="voce-field">
        <label>Note (no link/email)</label>
        <input type="text" value={v.note}
          onChange={(e) => setVoce(idx, { note: e.target.value })}
          placeholder="Es. consegna da 8€ / solo in combo con animazione" />
      </div>
    </div>
  );

  const principali = voci.map((v, i) => ({ v, i })).filter((x) => x.v.tipo !== 'extra');
  const extra = voci.map((v, i) => ({ v, i })).filter((x) => x.v.tipo === 'extra');

  return (
    <div className="voci-listino">
      <p className="form-hint">
        Aggiungi i tuoi pacchetti o prodotti con i relativi prezzi. Il range di prezzo della scheda
        viene calcolato automaticamente da queste voci.
      </p>

      {principali.map(({ v, i }) => renderVoce(v, i))}
      <button
        type="button" className="btn btn-secondary"
        onClick={() => aggiungiVoce('principale')} disabled={pieno}
      >
        <Plus size={18} /> Aggiungi pacchetto / prodotto
      </button>

      {extra.length > 0 && <h4 className="voci-extra-title">Extra / supplementi</h4>}
      {extra.map(({ v, i }) => renderVoce(v, i))}
      <button
        type="button" className="btn btn-secondary btn-extra"
        onClick={() => aggiungiVoce('extra')} disabled={pieno}
      >
        <Plus size={18} /> Aggiungi extra
      </button>

      {pieno && Number.isFinite(maxVoci) && (
        <div className="voci-limite">
          <p>
            Con il piano gratuito puoi inserire al massimo <strong>{maxVoci} voci</strong> nel listino.
            Passa a Pro per averne illimitate.
          </p>
          {onUpgrade && (
            <button type="button" className="btn btn-primary" onClick={onUpgrade}>
              Passa a Pro
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default VociListino;
